<template>
	<span>
		<a :href="url" class="chip-link" v-if="enabled" @click="fileRequested" target="_blank">
			<v-chip color="blue lighten-5" text-color="blue lighten-1">
				<v-avatar :color="iconColor">
					<v-icon small color="white">fal fa-arrow-circle-down</v-icon>
				</v-avatar>
				{{label}}
			</v-chip>
		</a>
		<v-chip v-else class="chip-button static" color="blue-grey lighten-5" text-color="blue-grey lighten-1">
			<v-avatar color="blue-grey lighten-3">
				<v-icon small color="white">fal fa-arrow-circle-down</v-icon>
			</v-avatar>
			{{label}}
		</v-chip>
	</span>
</template>

<script>
import api from "../api";

export default {
	props: ["label", "id", "type", "enabled", "warning"],
	data() {
		return {};
	},
	computed: {
		url() {
			return api.fileDownload(this.id, this.type);
		},
		iconColor() {
			return this.warning ? "amber lighten-2" : "blue lighten-3";
		},
	},
	methods: {
		fileRequested() {
			this.showToast("success", "File Requested");
		},
	},
};
</script>
